export default __webpack_public_path__ + "static/media/artificialIntelligenceOn.8766b13f.svg";